/* eslint-disable @nx/enforce-module-boundaries */
import { Component, Injector, OnInit, inject } from '@angular/core'
import { Router, RouterOutlet } from '@angular/router'
import { environment } from '@navix/shared/environments'
import { AngularPlugin } from '@microsoft/applicationinsights-angularplugin-js'
import { DefaultAngularErrorHandlerWrapper } from '../handlers/default-angular-error-handler-wrapper'
import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import { Userpilot } from 'userpilot'
import { redactDocumentViewerTelemetry } from './telemetry/redact-document-viewer-urls'

@Component({
  standalone: true,
  imports: [RouterOutlet],
  selector: 'navix-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  private readonly router = inject(Router)
  private readonly injector = inject(Injector)

  ngOnInit(): void {
    try {
      this.initializeApplicationInsights()
      this.initializeUserpilot()
    } catch (e) {
      console.error('Cannot initialize Application Insights', e)
    }
  }

  private initializeUserpilot() {
    if (!environment.userpilot?.token) {
      console.warn('Userpilot token not configured')
      return
    }
    Userpilot.initialize(environment.userpilot.token)
  }

  private initializeApplicationInsights() {
    if (environment.appInsights.connectionString === '') return
    const angularPlugin = new AngularPlugin(this.injector)
    const appInsights = new ApplicationInsights({
      config: {
        connectionString: environment.appInsights.connectionString,
        extensions: [angularPlugin],
        extensionConfig: {
          [angularPlugin.identifier]: {
            router: this.router,
            errorServices: [new DefaultAngularErrorHandlerWrapper()]
          }
        },
        enableCorsCorrelation: false,
        enableAutoRouteTracking: true,
        autoTrackPageVisitTime: true,
        enableRequestHeaderTracking: true
      }
    })
    // Registered before loading: the Angular plugin sends the first page view during load, and
    // the document viewer's route carries SAS links.
    appInsights.addTelemetryInitializer(redactDocumentViewerTelemetry)
    appInsights.loadAppInsights()
  }
}
